// extracted by mini-css-extract-plugin
export var badge = "_i4-2";
export var detailsPanel = "_i4-0";
export var resultRow = "_i4-1";